import * as React from "react";
const SvgDownload20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 18,
        fill: "black",
        viewBox: "0 0 17 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "m9.05 12.368 5.146-5.147-1.414-1.414L10 8.59V.004H8V8.49L5.316 5.806 3.9 7.221l5.148 5.147Z"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M.999 11.087h2V15H15l-.001-3.913h2v6h-16v-6Z"
    })
  );
export default SvgDownload20Px;
